import React from 'react';
import {
  Placeholder,
  RouteData,
  ComponentRendering,
  WithSitecoreContextProps,
} from '@sitecore-jss/sitecore-jss-react';
import { styled } from '@mui/material/styles';
import { Container, Grid } from '@mui/material';

type RenderingProps = WithSitecoreContextProps & {
  rendering: RouteData | ComponentRendering;
};

const ContainerFullWidth = styled(Container)(({ theme }) => ({
  padding: 0,
  maxWidth: '100%',
  marginTop: '40px',
}));

const SectionFullWidth = ({ rendering }: RenderingProps): React.JSX.Element => {
  return (
    <ContainerFullWidth maxWidth={false} disableGutters>
      <Grid>
        <Grid item xs={12}>
          <Placeholder name="section_full_width" rendering={rendering} />
        </Grid>
      </Grid>
    </ContainerFullWidth>
  );
};

export default SectionFullWidth;
